enum DemandReportsActionTypes {
	DEMAND_REPORT_GET_REPORT = 'demandReports/DEMAND_REPORT_GET_REPORT',
	DEMAND_REPORT_GET_REPORTS = 'demandReports/DEMAND_REPORT_GET_REPORTS',
	DEMAND_REPORT_GET_REPORTS_SUCCESS = 'demandReports/DEMAND_REPORT_GET_REPORTS_SUCCESS',
	DEMAND_REPORT_GET_REPORTS_FAILURE = 'demandReports/DEMAND_REPORT_GET_REPORTS_FAILURE',
	DEMAND_REPORT_GET_ALL_REPORTS_SUCCESS = 'demandReports/DEMAND_REPORT_GET_ALL_REPORTS_SUCCESS',
	DEMAND_REPORT_GET_ALL_REPORTS_NO_REPORTS = 'demandReports/DEMAND_REPORT_GET_ALL_REPORTS_NO_REPORTS',
	DEMAND_REPORT_RESET_DEMAND_REPORT_FAILURE = 'demandReports/DEMAND_REPORT_RESET_DEMAND_REPORT_FAILURE'
}

export { DemandReportsActionTypes };
